import React from 'react';

import styles from './Nudge.scss';

export interface Props {
  chestsCount?: number;
}

const Nudge: React.FC<Props> = (props) => (
  <span className={styles.nudge}>
    {props.chestsCount ? (props.chestsCount <= 99 ? props.chestsCount : '99+') : '!'}
  </span>
);

export default Nudge;
